import React from 'react';

import cs from 'classnames';

import { ia } from 'lib/helpers/utility';

import { AlertContent } from 'components/shared/Alert/Alert';
import Button from 'components/shared/Buttons/Button';

import selectedHeaders from '../lib/selectedHeader';

import ImportSelectItem from './ImportSelectItem';

const colors = {
  warning: 'warning',
  success: 'success',
  error: 'danger',
  default: 'primary'
};

const SubmitFile = ({
  file,
  show,
  headers,
  headerValue,
  patientDetailsFormat,
  setPatientDetailsFormat,
  columnHeaderOptions,
  setShow,
  setHeaderValue,
  setColumnHeaderOptions,
  handleUploadFile,
  dobFormatRef,
  addressFormatRef,
  nameFormatRef,
  policyStartDateFormatRef,
  policyEndDateFormatRef,
  providerNameFormatRef,
  transactionAmountFormatRef,
  transactionAmountSelfFormatRef
}) => {
  const handleHeaderSelect = async (e, index) => {
    await selectedHeaders({
      e,
      index,
      headerValue,
      show,
      setHeaderValue,
      setColumnHeaderOptions,
      setShow,
      dobFormatRef,
      nameFormatRef,
      policyStartDateFormatRef,
      policyEndDateFormatRef,
      providerNameFormatRef,
      transactionAmountFormatRef,
      transactionAmountSelfFormatRef
    });
  };

  const onChangeHandler = (event, key, selectRef, index) => {
    setPatientDetailsFormat((prevState) => ({
      ...prevState,
      [key]: event
    }));
    selectRef.current = event;
    setTimeout(() => handleHeaderSelect(headerValue[index], index), 100);
  };

  const refs = {
    dobFormatRef,
    addressFormatRef,
    nameFormatRef,
    policyStartDateFormatRef,
    policyEndDateFormatRef,
    providerNameFormatRef,
    transactionAmountFormatRef,
    transactionAmountSelfFormatRef
  };

  return (
    <div className="mx-auto my-auto flex h-fit w-fit flex-col justify-center overflow-auto rounded-lg border-none bg-white p-2 transition duration-300">
      <span className="py-1 text-center text-xl font-bold">Patient Import</span>
      <span className="text-l py-1 text-center font-bold">Step 3/4</span>
      {ia(show.messages) && (
        <div className="flex flex-col self-center">
          <div>
            {show.messages.map((v, index) => (
              <AlertContent
                key={index}
                message={v.message}
                color={cs(colors[v.className] || colors.default)}
              />
            ))}
          </div>
        </div>
      )}
      <div className="h-60vh w-50vw flex min-h-[20rem] min-w-[20rem] flex-col overflow-auto">
        <table>
          <thead>
            <tr>
              <td>Name</td>
              <td>Match</td>
              <td>Example 1</td>
              <td>Example 2</td>
              <td>Example 3</td>
            </tr>
          </thead>
          <tbody>
            {ia(headers) &&
              headers.map((v, i) => (
                <tr key={`patient-import-header-entry-${i}`}>
                  <td>{v}</td>
                  <td>
                    <ImportSelectItem
                      headerValue={headerValue[i]}
                      patientDetailsFormat={patientDetailsFormat}
                      columnHeaderOptions={columnHeaderOptions}
                      onChangeHandler={onChangeHandler}
                      handleHeaderSelect={handleHeaderSelect}
                      index={i}
                      refs={refs}
                    />
                  </td>
                  <td>{file.sampleEntries[0][i]}</td>
                  <td>{file.sampleEntries[1][i]}</td>
                  <td>{file.sampleEntries[2][i]}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="flex h-20 flex-row justify-around p-1">
        <Button
          text="Back"
          onClick={() => setShow({ ...show, stage: 'uploadFile' })}
          color="primary"
        />

        <Button
          text="Upload"
          onClick={handleUploadFile}
          loading={show?.loading}
          disabled={show?.holds}
          color="success"
        />
      </div>
    </div>
  );
};

export default SubmitFile;
